import { render, staticRenderFns } from "./OrderCountIndicator.vue?vue&type=template&id=37421ba0&scoped=true"
import script from "./OrderCountIndicator.vue?vue&type=script&lang=js"
export * from "./OrderCountIndicator.vue?vue&type=script&lang=js"
import style0 from "./OrderCountIndicator.vue?vue&type=style&index=0&id=37421ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37421ba0",
  null
  
)

export default component.exports